import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, normalizeClass as _normalizeClass } from "vue"

import {computed} from "vue";
import {columnAmount} from "@/stores/gallery";

import {galleryColumn} from "@/stores/gallery";
import PreviewImage from "@/components/gallery/PreviewImage.vue";


export default /*#__PURE__*/_defineComponent({
  props: {
  idx: {
    type: Number,
    default() {
      return -1
    }
  },
  max: {
    type: Number,
  },
  selectionMode: {
    type: Boolean,
    default: false,
  },
  selection: {
    type: Array,
    required: true,
    default() {
      return []
    }
  }
},
  emits: ["imageSelected", "imageUnselected", "tooManyImagesSelected"],
  setup(__props, { emit }: { emit: ({
  (e: 'imageSelected', val: number):void
  (e: 'imageUnselected', val:number):void
  (e: 'tooManyImagesSelected'): void
}), expose: any, slots: any, attrs: any }) {

const props = __props



const classes = computed(() => {
  return columnAmount.value === 4 ? ['w-25'] : ['w-100']
})



const images = computed(() => {
  return galleryColumn(props.idx)?.value
})


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["d-flex flex-column", _unref(classes)])
  }, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(images), (image) => {
      return (_openBlock(), _createBlock(PreviewImage, {
        key: image.timestamp,
        image: image,
        selectionMode: __props.selectionMode,
        selection: __props.selection,
        onImageSelected: _cache[0] || (_cache[0] = (val) => emit('imageSelected', val)),
        onImageUnselected: _cache[1] || (_cache[1] = (val) => emit('imageUnselected', val)),
        onTooManyImagesSelected: _cache[2] || (_cache[2] = () => emit('tooManyImagesSelected'))
      }, null, 8, ["image", "selectionMode", "selection"]))
    }), 128))
  ], 2))
}
}

})